


























import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'product-filter-list',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;
  @Prop({default: () => []}) readonly subCategories: Array<object>;
  @Prop() readonly categoryName: string;

  private get totalProductCount(): number {
    return this.$store.getters[`${this.dataSource}/totalItemCount`];
  }

  private get filterList(): Array<object> {
    return (this.$store.getters[`${this.dataSource}/filterList`] || []).filter((f) => f['is_visible'] || f['type'] === 'price');
  }

  private determineFilterComponent(filter: object): string {
    if (filter['type'] === 'price') {
      return 'catalog-product-list-price-filter';
    }

    if (filter['renderer'] === 'swatch_visual') {
      return 'catalog-product-list-swatch-filter';
    }

    return 'catalog-product-list-attribute-filter';
  }

  private scrollToProducts(): void {
    setTimeout(() => {
      const topToolbar = document.getElementsByClassName('catalog__category-toolbar-top');
      if (topToolbar.length) {
        window.scrollTo({top: (topToolbar[0] as HTMLElement).offsetTop - 220, left: 0, behavior: 'smooth'});
      }
    }, 100);
  }

  private mounted(): void {
    const placeholder = document.getElementById('filterPlaceholder');
    if (placeholder) {
      placeholder.style.display = 'none';
    }
  }
}
